import { render } from "./HomePotential.vue?vue&type=template&id=c1e56bf4"
import script from "./HomePotential.vue?vue&type=script&lang=js"
export * from "./HomePotential.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__